import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import InternalServerError from "../pages/general/internal-server-error/internal-server-error";
import ResourceNotFound from "../pages/general/resource-not-found/resource-not-found";
import FAQ from "../pages/general/faq/faq";

/*
  Content - component for layout main content
  props:
  1. modules - allowed modules to be rendered
*/
const Content = ({modules, role}) => {
  /*
    JSX Markup for Content with switch of routes and links
    for allowed content of modules
   */
  const defaultPath = modules.filter(m => m.default)[0];
  return (
    <Container fluid="xl">
      <Switch>
        { modules.map( (route, i) => {
          return (
            <Route
              key={i}
              path={route.path}
              name={route.name}
              component={route.component}
            />
          )
        })}
        <Route path="/resource-not-found" >
          <ResourceNotFound />
        </Route>
        <Route path="/internal-server-error" >
          <InternalServerError />
        </Route>
        <Route path="/faq" >
          <FAQ role={role}/>
        </Route>
        {defaultPath ? <Route exact path="*">
          <Redirect to={defaultPath.path} />
        </Route> : ''}
      </Switch>
    </Container>
  );
}

export default Content;
